import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SelectableOption } from '../../../../utils/form-utils/selectable-option.type';
import { CrudViewFormItemType } from '../../../../utils/edit-form/crud-view-form-item-type.enum';
import { MenuConfig } from '../../../../utils/menu/menu-config.interface';
import { MenuMode } from '../../../../utils/menu/menu-mode.enum';
import { MenuActionBehavior } from '../../../../utils/menu/menu-action-behavior.enum';
import { Menu } from '../../../../utils/menu/menu.interface';

@Component({
    selector: 'rappider-form-builder-menu',
    templateUrl: './form-builder-menu.component.html',
    styleUrls: ['./form-builder-menu.component.scss']
})
export class FormBuilderMenuComponent implements OnChanges {

    @Input() formItems: SelectableOption[];
    @Output() formItemSelected = new EventEmitter<string>();

    menuConfig: MenuConfig;
    CrudViewFormItemType = CrudViewFormItemType;

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.formItems){
            this.createMenuConfig();
        }
    }

    createMenuConfig() {
        const menuItems: Menu[] = this.formItems?.map(option => ({
            label: option.key,
            actionBehavior: MenuActionBehavior.Emit,
            redirectUrl: null,
            id: option.value,
            data: {
                formFieldType: option.value,
                key: option.key
            }
        }));

        this.menuConfig = {
            mode: MenuMode.Inline,
            items: menuItems
        };
    }

    onMenuItemClick(menuItem: Menu) {
        this.formItemSelected.emit(menuItem.data?.formFieldType);
    }
}
